import { z } from "zod";
import { PaginatedSearchSchema } from "./paginated-search";

export const OrderEntryCloseSearchSchema = PaginatedSearchSchema.extend({
  filters: z
    .array(
      z.object({
        id: z.enum(["runDate", "targetDate"]),
        value: z.union([z.string(), z.array(z.string())]),
        variant: z.string(),
        operator: z.string(),
        filterId: z.string(),
      }),
    )
    .optional()
    .default(() => []),
  sort: z
    .enum(["runDate.asc", "runDate.desc", "targetDate.asc", "targetDate.desc"])
    .optional(),
});
